import { Box } from "@mui/system";
import React from "react";
import { Helmet } from "react-helmet";
import styles from "./pageTitle.module.scss";
import PropTypes from "prop-types";
import Button from "../buttons/Buttons";

const PageTitle = (props) => {
  const { title, isBackButtonNeed = false, handleBackClick } = props;
  return (
    <Box className={styles.pageTitleWrapper} data-testid="page-title">
      <Box className={"actionButtonWrapper"}>
        {isBackButtonNeed ? (
          <Button
            title="Back"
            iconStyle={styles.Back}
            buttonType="muibtn-secondary-with-icon"
            withIcon={true}
            handleClick={handleBackClick}
          />
        ) : null}
      </Box>
      <Helmet>
        <title>{title} | 100% OH </title>
      </Helmet>
      <Box className={styles.title}>{title}</Box>
    </Box>
  );
};

export default PageTitle;
PageTitle.propTypes = {
  title: PropTypes.any,
  isBackButtonNeed: PropTypes.any,
  handleBackClick: PropTypes.any,
};
